// Mock data for the My Activity Review screen. Values mirror the approved
// HTML's exact example figures so the port renders identically.
export interface AttributionRow {
  id: string;
  customer: string;
  date: string;
  value: number;
  credit: number | null;
  status: 'credited' | 'pending';
  description: string;
}

export const ATTRIBUTION_ROWS: AttributionRow[] = [
  {
    id: 'EX-1048',
    customer: 'Sarah Mitchell',
    date: 'Sep 20',
    value: 300,
    credit: 300,
    status: 'credited',
    description:
      'Illustrative confirmed attribution to Jamie. The live view shows the applied rule and supporting activity.',
  },
  {
    id: 'EX-1047',
    customer: 'Michael Thompson',
    date: 'Sep 20',
    value: 420,
    credit: 420,
    status: 'credited',
    description:
      'Illustrative confirmed attribution to Jamie. Order attribution can differ from primary account ownership.',
  },
  {
    id: 'EX-1046',
    customer: 'Sample customer A',
    date: 'Sep 19',
    value: 340,
    credit: null,
    status: 'pending',
    description:
      'The system is checking attribution evidence. No amount is included in credited sales yet.',
  },
  {
    id: 'EX-1045',
    customer: 'Sample customer B',
    date: 'Sep 19',
    value: 300,
    credit: null,
    status: 'pending',
    description:
      'The system is checking attribution evidence. No amount is included in credited sales yet.',
  },
  {
    id: 'EX-1044',
    customer: 'Sample customer C',
    date: 'Sep 18',
    value: 300,
    credit: null,
    status: 'pending',
    description:
      'The system is checking attribution evidence. No amount is included in credited sales yet.',
  },
];

export interface MonthHistoryEntry {
  label: string;
  sales: number;
}

export const MONTH_HISTORY: MonthHistoryEntry[] = [
  { label: 'Apr', sales: 14280 },
  { label: 'May', sales: 16800 },
  { label: 'Jun', sales: 17400 },
  { label: 'Jul', sales: 19800 },
  { label: 'Aug', sales: 22400 },
  { label: 'Sep', sales: 18420 },
];

export type PeriodKey = 'sep' | 'aug' | 'jul';

export interface PeriodData {
  month: string;
  sales: number;
  orders: number;
  rank: number;
  index: number;
}

export const PERIOD_DATA: Record<PeriodKey, PeriodData> = {
  sep: { month: 'September', sales: 18420, orders: 64, rank: 3, index: 5 },
  aug: { month: 'August', sales: 22400, orders: 80, rank: 2, index: 4 },
  jul: { month: 'July', sales: 19800, orders: 72, rank: 3, index: 3 },
};

export type RankPeriod = 'today' | 'week' | 'month';

export interface LeaderboardPeriodDef {
  values: number[];
  label: string;
  context: string;
}

export const LEADERBOARD_PERIODS: Record<RankPeriod, LeaderboardPeriodDef> = {
  today: {
    values: [1680, 1440, 1260, 980, 850, 720],
    label: 'Today · Through 1:00 PM',
    context: 'today',
  },
  week: {
    values: [5780, 5100, 4860, 4530, 3980, 3640],
    label: 'This week · Through the example snapshot',
    context: 'this week',
  },
  month: {
    values: [21840, 18960, 18420, 17280, 15650, 14200],
    label: 'September · Through Sep 20',
    context: 'this month',
  },
};

export const LEADERBOARD_ROWS = [
  { rank: 1, name: 'Alex Morgan', subtitle: 'Example rep', you: false },
  { rank: 2, name: 'Taylor Brooks', subtitle: 'Example rep', you: false },
  { rank: 3, name: 'Jamie Dorsey', subtitle: 'Keep the momentum going', you: true },
  { rank: 4, name: 'Casey Reed', subtitle: 'Example rep', you: false },
  { rank: 5, name: 'Jordan Ellis', subtitle: 'Example rep', you: false },
  { rank: 6, name: 'Morgan Lane', subtitle: 'Example rep', you: false },
];

export function formatDollars(n: number): string {
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
}

export function formatMoney(n: number): string {
  return `$${n.toFixed(2)}`;
}
